<div class="page-heading text-center text-uppercase">
  {{ title }}
  <span *ngIf="applicationExternalId">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ applicationExternalId }}</span>
</div>
